import { GetStaticPropsResult } from 'next'
import React, { ReactElement } from 'react'
import { getMoviesBillboard } from 'src/movies'
import { PageMeta } from 'src/pages'
import { Layout } from '@/components/Layout'
import homeData from '@/content/home.json'
import { getCinemas } from '@/src/cinemas'
import { Container } from '@/components/utils'
import { Cinema } from '@/src/types'
import {
  NewsletterSection,
  NewsletterSectionProps,
} from '@/components/patterns/NewsletterSection'
import { CinemaMap } from '@/components/patterns/CinemaMap'
import { CTASection, CTASectionProps } from '@/components/patterns/CtaSection'
import {
  CinemaHeader,
  CinemaHeaderProps,
} from '@/components/patterns/CinemaHeader'
import {
  CinemaBillboard,
  CinemaBillboardProps,
} from '@/components/patterns/CinemaBillboard'

interface CinemaPageProps {
  meta: PageMeta
  cinema: Cinema
  newsletter: NewsletterSectionProps
  cta: CTASectionProps
  header: CinemaHeaderProps
  cinemaBillboard: CinemaBillboardProps
}

export async function getStaticPaths() {
  const cinemas = await getCinemas()

  return {
    paths: cinemas.map((cinema) => ({
      params: { id: cinema.id },
    })),
    fallback: false,
  }
}

export async function getStaticProps({
  params,
}): Promise<GetStaticPropsResult<CinemaPageProps>> {
  const cinemas = await getCinemas()

  const cinema = cinemas.find((c) => c.id === params.id)
  const { id, name, address, city, cover, addresslink, phone, email } = cinema
  const billboardData = await getMoviesBillboard(id)

  return {
    props: {
      meta: {
        title: name,
        description: name,
      },
      cinema,
      newsletter: homeData.newsletter,
      cta: homeData.cta,
      cinemaBillboard: {
        currentMovie: billboardData.current.length
          ? billboardData.current[0]
          : null,
        soonerMovies: billboardData.incoming,
        previousMovies: billboardData.previous,
      },
      header: {
        title: name,
        subtitle: city,
        location: address,
        locationLink: addresslink || null,
        picture: cover || '/img/cinema-hero.jpg',
        phone,
        email,
      },
    },
  }
}

export default function CinemaPage({
  meta,
  cinema,
  newsletter,
  cta,
  header,
  cinemaBillboard,
}: CinemaPageProps): ReactElement {
  return (
    <Layout meta={meta}>
      <CinemaHeader {...header} />
      <CinemaMap cinemas={[cinema]} zoom={18} />
      <CTASection {...cta} />
      <Container>
        <CinemaBillboard {...cinemaBillboard} />
      </Container>
      <NewsletterSection {...newsletter} />
    </Layout>
  )
}
